<template>
  <t-select :class="`${prefixClass}-size-changer`" :size="size" :placeholder="current && itemPerPage ? current + itemPerPage : ''" @change="$_onTDropDownClick">
    <t-option v-for="i in range" :key="i" :value="i" :label="i + itemPerPage"></t-option>
  </t-select>
</template>
<script>
import Locale from '../../mixins/locale'
import { isPInt } from '../../utils/assist'
import TSelect from '../select/select.vue'
import { TListItem as TOption } from '../list'
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIXCLASS = `${PREFIX_CLASS}pagination__options`

export default {
  name: 'TPageSizer',
  components: {
    TSelect,
    TOption
  },
  mixins: [Locale],
  props: {
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'sm', 'lg'].indexOf(value) > -1
      }
    },
    range: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      validator: value => isPInt(value) && value > 0,
      default: 5
    }
  },
  data() {
    return {
      prefixClass: PREFIXCLASS,
      current: this.$_getCurrent(),
      iconType: false
    }
  },
  computed: {
    itemPerPage() {
      return this.t('t.page.page')
    }
  },
  watch: {
    range(val) {
      if (val && val[0]) {
        if (val[0] !== this.current) {
          this.$_onTDropDownClick(val[0])
        }
      }
    }
  },
  methods: {
    // 设置私有方法
    $_onTDropDownClick(val) {
      this.current = val
      this.$emit('on-change', val)
    },
    $_onTDropDownVisibleChange(visible) {
      this.iconType = visible
    },
    $_getCurrent() {
      if (this.range[0] !== this.pageSize) {
        if (this.range.includes(this.pageSize)) {
          return this.pageSize
        }
      } else {
        return this.range[0]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/pager/sizer.vue